export default function ArrowLeft({ color = "#053137" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M17 7H7M7 7V17M7 7L17 17"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="square"
      />
    </svg>
  );
}
